import React from "react";

import { func, string } from "prop-types";
import { useTranslation } from "@lib/i18n";

import MapButton from "../shared/MapButton";
import GpsIcon from "../shared/Icons/GpsIcon";

import { mapGeolocationToAddress } from "@lib/mapGeolocationToAddress";
import { toast } from "@lib/reactToastify";
import { lazyLoadGoogleMaps } from "@shared/v2/widgets/googleMapsWidget";

import gtm from "@gtm/core";
import { geolocalisationEvent } from "@gtm/events/testdrive";
import Icon from "@components/shared/Icons/Icon";

const CurrentLocationButton = ({ setAddress }) => {
  const { t, i18n } = useTranslation();

  const setAddressFromGeolocation = async location => {
    try {
      const maps = await lazyLoadGoogleMaps(i18n.language);
      const geocoder = new maps.Geocoder();

      geocoder.geocode({ location }, locationAddress => {
        const { geometry, address_components } = locationAddress[0];

        const currentAddress = mapGeolocationToAddress(
          address_components,
          geometry
        );

        setAddress(currentAddress);
      });
    } catch (error) {
      toast.error(
        t("notify.apiDefaultError"),
        {
          toastId: "google-maps-load-error",
        },
        error
      );
    }
  };

  const getCurrentPosition = () => {
    gtm.fire(geolocalisationEvent());

    if (!navigator.geolocation) {
      toast.error(
        t("notify.browserNoGeolocation"),
        {
          toastId: "browser-no-geolocation",
        },
        "Missing navigator.geolocation"
      );

      return;
    }

    navigator.geolocation.getCurrentPosition(({ coords }) =>
      setAddressFromGeolocation({
        lat: coords.latitude,
        lng: coords.longitude,
      })
    );
  };

  return (
    <MapButton onClick={getCurrentPosition}>
      <Icon className="size-full text-primaryDark" icon={<GpsIcon />} />
    </MapButton>
  );
};

CurrentLocationButton.propTypes = {
  setAddress: func.isRequired,
  accentColor: string.isRequired,
};

export default CurrentLocationButton;
